export default function (ModalService) {
    return function (vehicle) {
        return ModalService.showModal({
            controller: require('../../controllers/vehicles/edit/editVehicleCtrl'),
            template: require('../../controllers/vehicles/edit/edit-vehicle.html'),
            controllerAs: 'editVehicle',
            inputs: {
                vehicle
            }
        });
    };
}



// WEBPACK FOOTER //
// ./Client/app/tasks/services/vehicles/openEditVehicleModal.js